import { Button, Stack } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import UndoIcon from '@mui/icons-material/Undo';

// Teilnahme-Aktionen (zusagen/absagen/ändern/zurückziehen) für einen Termin.
function TerminAktionen({ teilnahmeStatus, terminId, onStatus, onRemove }) {
    return (
        <Stack spacing={1.5} sx={{ mt: 1 }}>
            {/* Zusage/Absage Buttons */}
            {teilnahmeStatus !== 'zusage' && teilnahmeStatus !== 'absage' && (
                <Stack direction="row" spacing={1}>
                    <Button
                        variant="contained"
                        startIcon={<ThumbUpIcon />}
                        onClick={() => onStatus(terminId, 'zusage')}
                        fullWidth
                        sx={{
                            background: 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)',
                            color: '#fff',
                            borderRadius: '12px',
                            py: 1.2,
                            textTransform: 'none',
                            fontWeight: 600,
                            boxShadow: '0 4px 12px rgba(34, 197, 94, 0.3)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #15803d 0%, #16a34a 100%)',
                            }
                        }}
                    >
                        Zusagen
                    </Button>
                    <Button
                        variant="contained"
                        startIcon={<ThumbDownIcon />}
                        onClick={() => onStatus(terminId, 'absage')}
                        fullWidth
                        sx={{
                            background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                            color: '#fff',
                            borderRadius: '12px',
                            py: 1.2,
                            textTransform: 'none',
                            fontWeight: 600,
                            boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #b91c1c 0%, #dc2626 100%)',
                            }
                        }}
                    >
                        Absagen
                    </Button>
                </Stack>
            )}

            {/* Status ändern wenn bereits zugesagt/abgesagt */}
            {teilnahmeStatus === 'zusage' && (
                <Button
                    variant="outlined"
                    startIcon={<ThumbDownIcon />}
                    onClick={() => onStatus(terminId, 'absage')}
                    fullWidth
                    sx={{
                        borderColor: '#ef4444',
                        color: '#ef4444',
                        borderRadius: '12px',
                        py: 1.2,
                        textTransform: 'none',
                        '&:hover': {
                            borderColor: '#dc2626',
                            bgcolor: 'rgba(239, 68, 68, 0.05)'
                        }
                    }}
                >
                    Zu Absage ändern
                </Button>
            )}

            {teilnahmeStatus === 'absage' && (
                <Button
                    variant="outlined"
                    startIcon={<ThumbUpIcon />}
                    onClick={() => onStatus(terminId, 'zusage')}
                    fullWidth
                    sx={{
                        borderColor: '#22c55e',
                        color: '#22c55e',
                        borderRadius: '12px',
                        py: 1.2,
                        textTransform: 'none',
                        '&:hover': {
                            borderColor: '#16a34a',
                            bgcolor: 'rgba(34, 197, 94, 0.05)'
                        }
                    }}
                >
                    Zu Zusage ändern
                </Button>
            )}

            {/* Teilnahme zurückziehen */}
            {teilnahmeStatus && (
                <Button
                    variant="text"
                    startIcon={<UndoIcon />}
                    onClick={() => onRemove(terminId)}
                    fullWidth
                    sx={{
                        color: '#93c5fd',
                        textTransform: 'none',
                        fontSize: '0.9rem',
                        py: 1
                    }}
                >
                    Teilnahme zurückziehen
                </Button>
            )}
        </Stack>
    );
}

export default TerminAktionen;
